import { FC, ReactNode, createContext, useCallback, useContext, useState } from 'react';

type FormData = {
  records: Array<Record<string, any>>;
};
type FormContextValue = {
  formData: FormData;
  updateFormData: (data: { fieldName: string; value: any }) => void;
  summary: {
    [stepName: string]: {
      [storeName: string]: {
        value: any;
        displayName: string;
      };
    };
  };
  updateSummary: (data: {
    stepName: string;
    fieldName: { storeName: string; displayName: string };
    fieldValue: any;
  }) => void;
};
const FormContext = createContext<FormContextValue>({
  formData: [] as any,
  updateFormData: () => {},
  summary: {},
  updateSummary: () => {},
});

export const FormProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [summary, setFormSummary] = useState({});
  const [formData, setFormData] = useState<FormData>({
    records: [{}],
  });

  const updateFormData = useCallback((data: any) => {
    setFormData((prevState) => ({
      ...prevState,
      records: prevState.records.map((record, index) =>
        index === 0 ? { ...record, [data.fieldName]: data.value } : record
      ),
    }));
  }, []);

  const updateSummary = useCallback((data: any) => {
    setFormSummary((prevState) => ({
      ...prevState,
      [data.stepName]: {
        // @ts-expect-error I couldn't type it
        ...(prevState[data.stepName] || {}), // Preserve existing step data
        [data.fieldName.storeName]: {
          value: data.fieldValue,
          displayName: data.fieldName.displayName,
        },
      },
    }));
  }, []);

  return (
    <FormContext.Provider value={{ formData, updateFormData, summary, updateSummary }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);
